import React, { useEffect } from "react";
import { useSocket } from "../../Context/SockerContext";

const TestStripePayment = () => {
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;

    const handleUserSocketEmit = data => {
      if (data.event === "fetch_user_data") {
        /// 
      }
    };

    socket.on("user_socket_emit", handleUserSocketEmit);

    return () => {
      socket.off("user_socket_emit", handleUserSocketEmit);
    };
  }, [socket]);

  return (
    <div>
      <h3>Available Payment Methods</h3>
    </div>
  );
};

export default TestStripePayment;
